<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-card class="elevation-3">
    <v-col lg="12" class="px-0 px-md-3">
      <v-card v-if="isMobile" flat>
        <v-row no-gutters class="pa-2">
          <v-col cols="9">
            <v-card-title class="headline display-1">
              {{ $t("header.last_access") }}
            </v-card-title>
          </v-col>
          <v-col cols="3" md="6" class="mt-3 pr-2">
            <v-row justify="center">
              <v-dialog v-model="docFilterDialog">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    {{ $t("tableStatus.filter") }}
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ $t("tableStatus.filter") }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            :label="$t('tableStatus.per_status')"
                            :items="status"
                            clearable
                            v-model="selectedStatus"
                            multiple
                            chips
                          ></v-select>
                        </v-col>
                        <v-col cols="12">
                          <v-select
                            :label="$t('tableStatus.by_category')"
                            :items="categories"
                            clearable
                            v-model="selectedCategory"
                            multiple
                            chips
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="docFilterDialog = false"
                      >OK
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </v-col>

          <v-text-field
            v-model="search"
            append-icon="search"
            :label="$t('tableStatus.searchAll')"
            single-line
            hide-details
            class="mt-n2"
          ></v-text-field>
        </v-row>
      </v-card>

      <v-card flat v-else>
        <v-card-title class="headline display-1">
          {{ $t("tableTitle.list_access") }}
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            :label="$t('tableStatus.searchAll')"
            single-line
            hide-details
            class="mt-n2"
          >
          </v-text-field>
        </v-card-title>
        <v-card-text class="elevation-2 grey mt-n2 lighten-5 pt-2">
          <v-row>
            <v-col md="6" sm="12" class="mt-n5 mb-n5">
              <v-select
                :label="$t('tableStatus.filter_status')"
                :items="status"
                clearable
                v-model="selectedStatus"
                multiple
                chips
              ></v-select>
            </v-col>
            <v-col md="6" sm="12" class="mt-n5 mb-n5">
              <v-select
                :label="$t('tableStatus.by_category')"
                :items="categories"
                clearable
                multiple
                chips
                v-model="selectedCategory"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card-text class="px-2 px-md-4" id="incidentTable">
        <v-data-table
          :headers="accessheaders"
          :items="filteredItems"
          item-key="id"
          :loading="loading"
          @click:row="clicked"
          class="table is_bordered"
          sort-by="date"
          sort-desc
          group-by="room"
          :mobile-breakpoint="this.$vuetify.breakpoint.thresholds.md"
          :group-desc="false"
          :search="search"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:group.header="{ toggle, group, isOpen }">
            <td colspan="12" class="pl-0">
              <v-btn @click="toggle()" icon>
                <v-icon
                  >mdi-{{
                    isOpen
                      ? "arrow-up-drop-circle-outline"
                      : "arrow-down-drop-circle-outline"
                  }}</v-icon
                >
              </v-btn>
              <span class="primary--text">{{ group }}</span>
            </td>
          </template>

          <template v-slot:item="{ item, isMobile }">
            <mobile-rowAccess
              :item="item"
              :headers="accessmobileHeaders"
              v-if="isMobile"
              @expand="expandRow"
              :is-expanded="shoulExpand(item.id)"
              @n-expand="removeFromExpanded"
              @row-clicked="clicked"
            >
              <template v-slot:id="{ item }">
                {{ formatID(item.id) }}
              </template>
              <template v-slot:statusName="{ item }">
                <v-chip
                  label
                  small
                  :color="getStatus(item.status).color"
                  text-color="white"
                >
                  {{ getStatus(item.status).name }}
                </v-chip>
              </template>
              <template v-slot:content="{ item }">
                <div
                  class="incident description"
                  :class="{ 'test-class': isMobile }"
                  v-if="item.content"
                  v-html="decodeContent(item.content)"
                ></div>
              </template>
              <template v-slot:last_comment="{ item }">
                <div
                  v-if="item.last_comment"
                  class="incident comments"
                  v-html="decodeContent(item.last_comment)"
                ></div>
              </template>
              <template v-slot:itilcategories_id="{ item }">
                {{
                  item.itilcategories_id === 0
                    ? "Non Défini"
                    : item.itilcategories_id
                }}
              </template>
              <template v-slot:date="{ item }">
                {{
                  item.date ? moment(item.date).format("DD-MM-YYYY HH:mm") : ""
                }}
              </template>
              <template v-slot:solvedate="{ item }">
                {{
                  item.solvedate
                    ? moment(item.solvedate).format("DD-MM-YYYY HH:mm")
                    : ""
                }}
              </template>
            </mobile-rowAccess>
            <c-row
              v-else
              :item="item"
              :headers="accessheaders"
              rtl
              @click="clicked(item)"
            >
              <template v-slot:id="{ item }">
                {{ formatID(item.id) }}
              </template>
              <template v-slot:statusName="{ item }">
                <v-chip
                  label
                  small
                  :color="getStatus(item.status).color"
                  text-color="white"
                >
                  {{ getStatus(item.status).name }}
                </v-chip>
              </template>
              <template v-slot:content="{ item }">
                <div
                  class="incident description"
                  :class="{ 'test-class': isMobile }"
                  v-if="item.content"
                  v-html="decodeContent(item.content.slice(30, -34))"
                ></div>
              </template>
              <template v-slot:last_comment="{ item }">
                <div
                  v-if="item.last_comment"
                  class="incident comments"
                  v-html="decodeContent(item.last_comment)"
                ></div>
              </template>
              <template v-slot:itilcategories_id="{ item }">
                {{
                  item.itilcategories_id === 0
                    ? "Non Défini"
                    : item.itilcategories_id
                }}
              </template>

              <template v-slot:date="{ item }">
                {{
                  item.date ? moment(item.date).format("DD-MM-YYYY HH:mm") : ""
                }}
              </template>
              <template v-slot:solvedate="{ item }">
                {{
                  item.solvedate
                    ? moment(item.solvedate).format("DD-MM-YYYY HH:mm")
                    : ""
                }}
              </template>
            </c-row>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"> </v-pagination>
        </div>
      </v-card-text>
    </v-col>
  </v-card>
</template>
<script>
import {
  statusList,
  formatID,
  remove,
  accessheaders,
  accessmobileHeaders,
  loadStates
} from "../../utils";
import { Decoder } from "../../mixins/decodeContent";
import moment from "../../plugins/moment";
import Row from "../Row";
import MobileRowAccess from "./MobileRowAccess";
import { mapGetters } from "vuex";
import { LocalMixin } from "../../mixins/local";

export default {
  name: "Access",
  props: {
    tickets: {
      type: Array,
      default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    loaded: {
      type: Boolean,
      default: false
    }
  },
  components: { [Row.name]: Row, MobileRowAccess },
  data() {
    return {
      list: [],
      search: "",
      expanded: [],
      accessheaders: accessheaders(this.local),
      accessmobileHeaders,
      docFilterDialog: false,
      selectedTicket: undefined,
      dialog: false,
      status: [this.$t("tableStatus.new"), this.$t("tableStatus.closed")],
      selectedStatus: [
        this.$t("tableStatus.new"),
        this.$t("tableStatus.closed")
      ],
      categories: ["Acces"],
      selectedCategory: ["Acces"],
      loadStates,
      page: 1,
      pageCount: 0
    };
  },
  mixins: [Decoder, LocalMixin],
  mounted() {
    this.list = this.tickets;
    this.loadLastComment();
  },
  methods: {
    formatID,
    moment,
    getStatus(status) {
      return status
        ? statusList(this.local).find(el => el.status === status)
        : { name: "", color: "" };
    },
    clicked: function(row) {
      this.selectedTicket = row;
      this.dialog = true;
      /*this.$router.push({
        name: "lots.ticket.show",
        params: { id: this.$route.params.id, ticketId: row.id }
      });*/
    },
    dismissDialog() {
      this.dialog = false;
      this.selectedTicket = undefined;
    },
    customSort(items, index, sortDesc) {
      // The following is informations as far as I researched.
      // items: 'tickets' items
      // index: Enabled sort headers value. (black arrow status).
      // sortDesc: Whether enabled sort headers is desc
      if (!index[1]) return items;

      items.sort((a, b) => {
        const attribute = index[1];
        let sortA = a[attribute];
        let sortB = b[attribute];
        const dateAttributes = [
          "date",
          "solvedate",
          "attributdate",
          "date_mod"
        ];
        if (dateAttributes.includes(attribute)) {
          if (!sortA) {
            sortA = "2010-01-01 00:00";
          }
          if (!sortB) {
            sortB = "2010-01-01 00:00";
          }
          const dateA = moment(sortA, "YYYY-MM-DD HH:mm:ss");
          const dateB = moment(sortB, "YYYY-MM-DD HH:mm:ss");

          if (sortDesc[0]) {
            if (dateB.isAfter(dateA)) {
              return 1;
            } else if (dateA.isAfter(dateB)) {
              return -1;
            } else {
              return 0;
            }
          } else {
            if (dateA.isAfter(dateB)) {
              return 1;
            } else if (dateB.isAfter(dateA)) {
              return -1;
            } else {
              return 0;
            }
          }
        }
      });

      return items;
    },
    expandRow(item) {
      this.expanded.push(item);
    },
    shoulExpand(id) {
      return this.expanded.includes(id);
    },
    removeFromExpanded(id) {
      this.expanded = remove(this.expanded, r => r.id === id);
    },
    titleText(selectedTicket) {
      try {
        const title = this.getActiveEntity.completename.replace(" ", "");
        const parentsEntities = title.split(">");
        let assetTitle = "";
        if (this.$vuetify.breakpoint.smAndDown) {
          assetTitle =
            parentsEntities[2].slice(0, 10) +
            " > " +
            parentsEntities[3].slice(0, 10);

          assetTitle = selectedTicket.no_equipment
            ? assetTitle
            : assetTitle + " > " + selectedTicket.equipment.slice(0, 10);
        } else {
          assetTitle = parentsEntities[2] + " > " + parentsEntities[3];

          assetTitle = selectedTicket.no_equipment
            ? assetTitle
            : assetTitle + " > " + selectedTicket.equipment;
        }
        return assetTitle;
      } catch (error) {
        return "";
      }
    },
    loadLastComment() {
      this.list.forEach(async ticket => {
        ticket.last_comment = "";

        const ticketID = ticket.id;
        const followUps = this.getAllITILFollowups.filter(
          fl => fl.items_id === ticketID
        );
        const tasks = this.getTicketsTasks.filter(
          fl => fl.tickets_id === ticketID
        );
        const solutions = this.getAllITILSolutions.filter(
          fl => fl.items_id === ticketID
        );

        let alldata = followUps.concat(tasks).concat(solutions);

        let sortedData = alldata.sort((a, b) => {
          if (moment(a.date_creation).isAfter(moment(b.date_creation))) {
            return -1;
          } else if (moment(b.date_creation).isAfter(moment(a.date_creation))) {
            return 1;
          } else {
            return 0;
          }
        });

        const lastComment = sortedData[0] ? sortedData[0].content : null;

        ticket.last_comment = lastComment;
      });
    },
    resetHeader() {
      this.accessheaders = accessheaders(this.local);
    }
  },
  computed: {
    ...mapGetters([
      "getActiveEntity",
      "getAllITILSolutions",
      "getAllITILFollowups",
      "getTicketsTasks"
    ]),
    filteredItems() {
      return this.list.filter(i => {
        if (i.itilcategories_id === 0) {
          i.itilcategories_id = "Non défini";
        }
        return (
          ((this.selectedStatus.length === 0 ||
            this.selectedStatus.includes(i.statusName)) &&
            (this.selectedCategory.length === 0 ||
              this.selectedCategory.includes(i.itilcategories_id))) ||
          (!i.id && i.equipment)
        );
      });
    },
    isMobile() {
      return (
        this.$vuetify.breakpoint.width < this.$vuetify.breakpoint.thresholds.md
      );
    },
    itemsPerPage() {
      return this.isMobile ? 10 : 30;
    }
  },
  watch: {
    $route() {
      this.list = this.tickets;
      this.loadLastComment();
    },
    tickets() {
      this.list = this.tickets;
      this.loadLastComment();
    }
  }
};
</script>
<style>
/* Modifier la valeur de max-height pour fixer la hauteur des lignes du tableau */

:root {
  --max-height: 100px;
  --desc-max-width: 350px;
  --content-max-width: 200px;
}

tr:nth-of-type(even) {
  background-color: #f5f5f5;
}

.t-row {
  color: #2d2d2d;
}
.table.is-bordered tr:last-child th {
  border-bottom-width: 1px !important;
}
.table.is-bordered th {
  border-width: 1px !important;
  color: #363636 !important;
}
@media only screen and (max-width: 799px) and (min-width: 240px) {
  .table th {
    border: 1px solid #dbdbdb !important;
    padding: 0.5em 0.75em !important;
    vertical-align: middle !important;
  }
}
@media only screen and (max-width: 2800px) and (min-width: 800px) {
  .table th {
    border: 1px solid #dbdbdb !important;
    padding: 0.5em 0.75em !important;
    vertical-align: middle !important;
    background-color: var(--v-primary-base);
    color: white !important;
  }
}
.v-data-table table td {
  border-width: 1px !important;
  border: 1px solid #dbdbdb !important;
  vertical-align: middle !important;
}
.incident p {
  margin-bottom: 0 !important;
}
.resolu {
  color: white !important;
}
.description {
  max-width: var(--desc-max-width);
  max-height: var(--max-height);
  overflow: auto;
}

.comments {
  max-width: var(--content-max-width);
  max-height: var(--max-height);
  overflow: auto;
}
</style>
